// Pantalla de entrada de cada panel al iniciar sesion. El calendario es lo
// primero que miran empresa y trabajador; el resto entra por su raiz.
const INICIO_POR_PANEL: Record<string, string> = {
  'panel-empresa': '/panel-empresa/calendar',
  'panel-trabajador': '/panel-trabajador/workerCalendar',
};

export function rutaInicioPanel(rutaPanel: string | null | undefined): string {
  if (!rutaPanel) return '/';
  return INICIO_POR_PANEL[rutaPanel] ?? `/${rutaPanel}`;
}